<div class="flex-column h-100">
  <div class="configuration-wizard-header flex-column">
    <h5
      class="odx-title-5 h-100"
      i18n="@@gasWarningCenterConfiguration.selectGasWarningCenter.modules.header"
      data-testid="gasWarningCenterConfiguration.selectGasWarningCenter.modules.header"
    >
      Module für Gaswarnzentrale auswählen
    </h5>
    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
  </div>

  <odx-content-box class="flex-scroll">
    @if (inputModules().length > 0) {
      <h6 class="odx-title-6 sub-header" i18n="@@productConfiguration.gasWarningCenter.inputModules.header">Eingabemodule</h6>
      <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 bottom-padding">
        @for (inputModule of filteredInputModules(); track inputModule) {
          <app-product-card-with-quantity
            class="overflow-hidden"
            [productData]="inputModule"
            [showCosts]="showCosts()"
            [selectionMode]="selectionMode"
            [quantity]="getSelectedModuleQuantity(inputModule, 'input')"
            (quantityChanged$)="updateSelectedModule($event, inputModule, 'input')"
          >
            @if (inputModule.id) {
              <div class="feature">
                <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                <p class="odx-text--small">{{ inputModule.id }}</p>
              </div>
            }
          </app-product-card-with-quantity>
        }
      </div>
    }

    @if (relayModules().length > 0) {
      <h6 class="odx-title-6 sub-header" i18n="@@productConfiguration.gasWarningCenter.relayModules.header">Relaismodule</h6>
      <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 bottom-padding">
        @for (relayModule of filteredRelayModules(); track relayModule) {
          <app-product-card-with-quantity
            class="overflow-hidden"
            [productData]="relayModule"
            [showCosts]="showCosts()"
            [selectionMode]="selectionMode"
            [quantity]="getSelectedModuleQuantity(relayModule, 'relay')"
            (quantityChanged$)="updateSelectedModule($event, relayModule, 'relay')"
          >
            @if (relayModule.id) {
              <div class="feature">
                <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                <p class="odx-text--small">{{ relayModule.id }}</p>
              </div>
            }
          </app-product-card-with-quantity>
        }
      </div>
    }

    @if (gatewayModules().length > 0) {
      <h6 class="odx-title-6 sub-header" i18n="@@productConfiguration.gasWarningCenter.gatewayModules.header">Gatewaymodule</h6>
      <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 bottom-padding">
        @for (gatewayModule of filteredGatewayModules(); track gatewayModule) {
          <app-product-card-with-quantity
            class="overflow-hidden"
            [productData]="gatewayModule"
            [showCosts]="showCosts()"
            [selectionMode]="selectionMode"
            [quantity]="getSelectedModuleQuantity(gatewayModule, 'gateway')"
            (quantityChanged$)="updateSelectedModule($event, gatewayModule, 'gateway')"
          >
            @if (gatewayModule.id) {
              <div class="feature">
                <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                <p class="odx-text--small">{{ gatewayModule.id }}</p>
              </div>
            }
          </app-product-card-with-quantity>
        }
      </div>
    }

    @if (filteredInputModules().length === 0 && filteredRelayModules().length === 0 && filteredGatewayModules().length === 0) {
      <app-refresh-products-hint dataType="Module" i18n-dataType="@@global.modules"></app-refresh-products-hint>
    }
  </odx-content-box>
</div>
